import { Fragment, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";

import {
  faCircleArrowDown,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Backdrop from "../../../Backdrop";
import InfoIcon from "../../../InfoIcon";
import Filter from "./mobile/filter";
import { useOrder } from "../../../../hook/useOrder";
import { AddToCart } from "../../shopping-cart/AddToCart";

export default function MobileComponent() {
  const [mobileItems, setMobileItems] = useState();

  let filteredproducts = useSelector((state) => state.product.filteredProducts);

  const { userOrders, addOrder } = useOrder();

  let stateproducts = useSelector((state) => state.product.products);


  useEffect(() => {
    let items = [];
    let products = filteredproducts ?? stateproducts;

    if (products && Object.keys(products).length > 0) {

      products.forEach((product) => {
        const isFree = Number(product.price) === 0;
        let showOrder = isFree;
        let showPaidOrder = !isFree;

        if (userOrders) {
          let productOrder = userOrders.filter(
            (order) => order.product_id === product.id,
          );

          showOrder = isFree && productOrder.length === 0;
          showPaidOrder = !isFree && (
            productOrder.length === 0
            || productOrder.every((order) => order.expired || !order.active)
          );
        }

        items.push(<MobileItem key={product.id} product={product} showOrder={showOrder} addOrder={addOrder} showPaidOrder={showPaidOrder} />);
      });
    }
    setMobileItems(items);
  }, [filteredproducts, stateproducts, userOrders]);

  if (!mobileItems) {
    return <Skeleton count={50} />;
  }

  return (
    <Fragment>
      <Filter>{mobileItems}</Filter>
      <Backdrop />
    </Fragment>
  );
}

function MobileItem(props) {
  const { product, showOrder, addOrder, showPaidOrder } = props;

  const [showContent, setShowContent] = useState(false);

  return (
    <Fragment>
      <div
        className="mobile-overflow-card card shadow bg-white rounded p-3 mb-2"
        style={{ cursor: "pointer" }}
        onClick={() => {
          setShowContent(!showContent);
        }}
      >
        <div className="responsive-card-summary">
          <span>{product.title}</span>

          <span>{product.ptype}</span>
        </div>
        <InfoIcon icon={faCircleArrowDown} size="xl" />
      </div>
      {showContent && (
        <div className="table-responsive mb-3"><table className="mobile-details-table table table-striped table-bordered mb-0">
          <tbody>
            <tr>
              <th>Title</th>
              <td className="text-break">{product.title}</td>
            </tr>

            <tr>
              <th>Type</th>
              <td className="text-break">{product.ptype}</td>
            </tr>

            <tr>
              <th>Details</th>
              <td>
                <Link
                  className="btn btn-outline-secondary bgnt"
                  to={`/products/${product.id}`}

                  state={{
                    product
                  }}
                >
                  <InfoIcon icon={faInfoCircle} title="product details" />
                </Link>
              </td>
            </tr>
            {showOrder && (
              <tr>
                <th>Order</th>
                <td>

                  <button
                    className="btn btn-secondary"
                    style={{ width: "100%" }}
                    onClick={() => addOrder(product)}
                  >
                    Order
                  </button>

                </td>
              </tr>
            )}
            {showPaidOrder && (
              <tr>
                <th>Order</th>
                <td>
                  <AddToCart product={product} />
                </td>
              </tr>
            )}
            {!showPaidOrder && !showOrder && (
              <tr>
                <td colSpan={2}><div className="alert alert-success mb-0">You already have an active order.</div></td>
              </tr>
            )}
          </tbody>
        </table></div>
      )}
    </Fragment>
  );
}
